<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import firebase from "firebase/app";

let db = firebase.firestore();
let companiesRef = db.collection("companies");

export default {
  name: "Company",
  props: ["companyId"],
  mounted: function() {
      let $this = this;
       companiesRef
      .doc(this.companyId)
      .get()
      .then(function(storedCompany) {
        if (!storedCompany.exists) {
          this.$router.push({
            path: "/"
          });
          return;
        }
        $this.$store.dispatch("fetchSelectedCompany", storedCompany.data());
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
      });
  }
};
</script>

<style>
</style>